import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON025_Request,
  IAPI_CON025_Response,
  IAPI_CON020_Request,
  IAPI_CON020_Response,
} from "../../../type/apiType";

// 契約者・担当者情報参照API
// API仕様書_契約者
const httpAPI_CON025 = async (
  param: IAPI_CON025_Request
): Promise<IAPI_CON025_Response> => {
  let res = await http.post(ApiUrl.API_CON025, {
    ...param,
  });

  return res.data;
};

// 契約者・法人担当者情報更新API
// API仕様書_契約者
const httpAPI_CON020 = async (
  param: IAPI_CON020_Request
): Promise<IAPI_CON020_Response> => {
  let res = await http.post(ApiUrl.API_CON020, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON025, httpAPI_CON020 };
